"use strict";
const _ = require("lodash");
const ButtonControl = require('@gluenetworks/button_control');

class ModalNotificationRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("modal-notification-gl");
        this._rootElem.classList.add("modal_feedback_container");
        this._rootElem.component = this._model;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
    }

    _unregisterListeners() {
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr)
            .then(() => {
                //TODO set all class members to undefined here
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._titleElem = undefined;
                this._messageElem = undefined;
                this._actionsContainer = undefined;
            });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._titleElem = document.createElement('h2');
        this._messageElem = document.createElement('p');
        this._actionsContainer = document.createElement("div");
        this._actionsContainer.classList.add("actions_container");

        this._rootElem.appendChild(this._titleElem);
        this._rootElem.appendChild(this._messageElem);
        this._rootElem.appendChild(this._actionsContainer);

        this._renderTitle();
        this._renderMessage();
        this._renderActions();

        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderTitle() {
        this._titleElem.innerText = this._model.title;
    }

    _renderMessage() {
        if (this._model.isHTMLMsg()) {
            this._messageElem.innerHTML = this._model.msg;
        }
        else {
            this._messageElem.innerText = this._model.msg;
        }
    }

    _renderActions() {
        let confElem = this._renderAction(this._model.confirmationDeets);
        confElem.classList.add('confirmation_action');
        confElem.addEventListener("click", () => {
            this._model.confirm();
        });
        this._actionsContainer.appendChild(confElem);
    }

    _renderAction(deets) {
        let actionElem;
        let btn;
        switch (deets.type) {
            case 'text':
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true
                });
                actionElem = btn.renderer.rootElement;
                break;
            case 'destructive':
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true
                });
                actionElem = btn.renderer.rootElement;
                actionElem.classList.add('destructive');
                break;
            case 'additive':
                btn = new ButtonControl({
                    label: deets.text,
                    darkTheme: true
                });
                actionElem = btn.renderer.rootElement;
                actionElem.classList.add('additive');
                break;
        }

        if (deets.classes) {
            let classStr = deets.classes;
            if (_.isString(deets.classes)) {
                classStr = deets.classes.split(" ");
            }
            actionElem.classList.add.apply(actionElem.classList, classStr);
            actionElem.classList.add('action');
        }

        return actionElem;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ModalNotificationRenderer;